import {
  snippetCompletion,
  type Completion,
  type CompletionSource,
} from '@codemirror/autocomplete';

/**
 * Slash-command / snippet menu. Typing `/` in the editor opens a small menu of
 * Markdown scaffolds (table, code, mermaid, math, …). Selecting one replaces the
 * `/query` with a snippet template (with tab-stops where useful).
 */
const SNIPPETS: Completion[] = [
  snippetCompletion('| ${Column} | ${Column} |\n| --- | --- |\n| ${cell} | ${cell} |\n', {
    label: '/table',
    detail: 'Table',
    type: 'text',
  }),
  snippetCompletion('```${lang}\n${}\n```\n', {
    label: '/code',
    detail: 'Code block',
    type: 'text',
  }),
  snippetCompletion('```mermaid\nflowchart LR\n  ${A} --> ${B}\n```\n', {
    label: '/mermaid',
    detail: 'Mermaid diagram',
    type: 'text',
  }),
  snippetCompletion('$$\n${}\n$$\n', {
    label: '/math',
    detail: 'Math block (KaTeX)',
    type: 'text',
  }),
  snippetCompletion('- [ ] ${task}\n', {
    label: '/task',
    detail: 'Task list item',
    type: 'text',
  }),
  snippetCompletion('> [!NOTE]\n> ${}\n', {
    label: '/note',
    detail: 'GitHub alert',
    type: 'text',
  }),
  snippetCompletion('[${text}](${url})', {
    label: '/link',
    detail: 'Link',
    type: 'text',
  }),
  snippetCompletion('\n---\n', {
    label: '/hr',
    detail: 'Divider',
    type: 'text',
  }),
  {
    label: '/date',
    detail: "Today's date",
    type: 'text',
    apply: (view, _completion, from, to) => {
      const iso = new Date().toISOString().slice(0, 10);
      view.dispatch({
        changes: { from, to, insert: iso },
        selection: { anchor: from + iso.length },
      });
    },
  },
];

/** Completion source that fires on `/…` and offers the snippet menu. */
export const slashCompletions: CompletionSource = (ctx) => {
  const match = ctx.matchBefore(/\/\w*/);
  if (!match) return null;
  if (match.from === match.to && !ctx.explicit) return null;
  return { from: match.from, options: SNIPPETS, filter: true };
};
